import { PureComponent } from 'react'
import { track, tracking, TrackVisibility } from 'lib/analytics'
import { getItemType } from './common'
import { pick } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getFeedSessionNumber } from 'registry/reducers'
import { FeedItemLayout } from '../feed-item-layout'

// new metrics tracking HOC (using `react-tracking` -> `AVO`)
// this HOC wrap the feed item in a (feed item) metric context (feedItemId, ...)
// so any comp within this feed item can track event in the context of the feed item
// it also track feed item display
const FeedItemTrackingHOC = (WrappedComponent) => {
  @tracking((props, state) => {
    const {
      id: feedItemId,
      trackingProps, // tracking is sent by backend (feed_item responder) in (tracking: { item_session: 'xxx'} )
      currentFeedSession: feedSessionId,
      title: feedItemTitle,
      type,
      products,
    } = props

    const eventProps = {
      feedSessionId,
      feedItemId,
      feedItemTitle,
      feedItemType: getItemType(type, products),
      ...trackingProps,
    }

    // avo only support pre-definied props, remove any unknown props
    return pick(eventProps, [
      'event',
      'events', // event Method
      'eventCta',
      'eventLocation',
      'eventType', // event properties
      'feedSessionId',
      'feedItemId',
      'feedItemSession',
      'feedItemTitle',
      'feedItemType',
      'productIds', // feed properties
      'isRegistryOwner',
      'registryOwnerId',
      'registryId',
      'productRecommenderModelVersion',
    ])
  })
  class FeedItemTrackedHOC extends PureComponent {
    render() {
      // ⚠️ hacky but we have a double connect with a potential null component
      // FeedItemLayout may return null (if web don't handle this feed item)
      // but in our case WrappedComponent is already wrap by FeedItemHOC
      if (FeedItemLayout(this.props) == null) {
        return null
      }

      // `react-tracking` merge array value
      // https://github.com/nytimes/react-tracking/issues/164
      // so we're not passing productIds in the comp context (@tracking)
      // because it need to be override in the product click event
      const productIds =
        this.props.products && this.props.products.map((e) => e.id)

      const WrappedComponentWithTracking = tracking({
        events: [track.feedItemClicked],
        eventType: track.EventType.CLICK,
      })(WrappedComponent)

      return (
        <TrackVisibility
          eventProperties={{
            event: track.feedItemViewed,
            productIds,
          }}
        >
          <WrappedComponentWithTracking {...this.props} />
        </TrackVisibility>
      )
    }
  }
  return FeedItemTrackedHOC
}

const mapStateToProps = (state) => {
  return {
    currentFeedSession: getFeedSessionNumber(state),
  }
}

/**
 * FeedItemTrackingHOC
 * track visibility of the component (display of a feed element) -> avo
 * wrap the component in a react tracking context provider (feed related)
 *
 */
export default compose(connect(mapStateToProps, {}), FeedItemTrackingHOC)
